<template>
  <div>
    <RenderMoneyColumnValue
      :value="invoiceValue || 0"
      :max-fraction-digits="0"
    />
    |
    <RenderPercentageColumnValue
      :style="setInvoiceSummaryStatusColor()"
      :value="percentageInvoiceValue"
    />
  </div>
</template>

<script>
import {
  RenderMoneyColumnValue,
  RenderPercentageColumnValue,
} from '../../../ui/render';
import { setPanoramaInvoiceStatusColor } from '../utils';

export default {
  components: { RenderMoneyColumnValue, RenderPercentageColumnValue },
  props: {
    invoiceValue: {
      type: Number,
      default: 0,
    },
    percentageInvoiceValue: {
      type: Number,
      default: 0,
    },
    status: {
      type: String,
      default: '',
    },
  },
  methods: {
    /**
     * Retorna o estilo CSS associado a um status de resumo de fatura específico.
     *
     * @returns {string} O estilo CSS associado ao status de resumo da fatura.
     */
    setInvoiceSummaryStatusColor() {
      return this.status ? setPanoramaInvoiceStatusColor(this.status) : '';
    },
  },
};
</script>
